import React, { Component, ReactNode } from "react";
import { style } from "typestyle";

interface DropdownMenuProps {
  title: ReactNode;
  children: ReactNode[];
}

interface DropdownMenuState {
  isOpened: boolean;
}

export default class DropdownMenu extends Component<
  DropdownMenuProps,
  DropdownMenuState
> {
  handleDropButtonClick = () => {
    this.setState({
      isOpened: true,
    });
  };

  handleChildClick = () => {
    this.setState({
      isOpened: false,
    });
  };

  UNSAFE_componentWillMount() {
    this.setState({
      isOpened: false,
    });
  }

  render() {
    if (this.state.isOpened) {
      return (
        <div className={style({ position: "relative" })}>
          <div
            className={style({
              borderRadius: "2px",
              padding: "8px 0",
              position: "absolute",
              background: "white",
              boxShadow:
                "0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)",
              top: 0,
            })}
          >
            {this.props.children.map((child, i) => {
              return (
                <div
                  className={style({ width: "100%" })}
                  key={`dropdown-${i}`}
                  onClick={this.handleChildClick}
                >
                  {child}
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    return (
      <div className={style({ position: "relative" })}>
        <DropdownMenuItem
          onClick={this.handleDropButtonClick}
          label={this.props.title}
        />
      </div>
    );
  }
}

interface DropdownMenuItemProps {
  label: ReactNode;
  disabled?: boolean;
  onClick: () => void;
}

export const DropdownMenuItem = ({
  onClick,
  disabled,
  label,
}: DropdownMenuItemProps) => (
  <div
    className={style({
      background: "white",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      whiteSpace: "nowrap",
      cursor: "pointer",
      padding: "8px 16px",
      pointerEvents: disabled ? "none" : "all",
    })}
    onClick={onClick}
  >
    {label}
  </div>
);

export const DropdownMenuDivider = () => (
  <div
    className={style({
      width: "100%",
      border: "1px solid rgba(0,0,0,0.12)",
      margin: "8px 0",
    })}
  ></div>
);
